import { useInfiniteQuery } from 'react-query';
import { queryGet } from '@pocapan/shared/utils/queryClient';

const DEFAULT_PAGE = 15;

export default function useRepostsQuery({ postId, onlyQuotes = false, perPage }) {
  async function fetchPosts({ pageParam = 1 }) {
    const queryParams = new URLSearchParams({
      per_page: perPage || DEFAULT_PAGE,
      page: pageParam
    });

    if (onlyQuotes) {
      queryParams.append('post_type', 'Quotation');
    }

    const url = `/api/v1/posts/${postId}/reposts?${queryParams.toString()}`;
    try {
      const posts = await queryGet(url);
      return posts;
    } catch (_error) {
      throw new Error('Error fetching paginated data to get useRepostsQuery');
    }
  }

  const { data, isFetching, fetchNextPage, hasNextPage } = useInfiniteQuery(
    ['Reposts', postId, onlyQuotes],
    fetchPosts,
    {
      enabled: !!postId,
      getNextPageParam: (lastPage, _) => lastPage?.meta?.pagination?.nextPage
    }
  );

  return {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage
  };
}
